<div class="mb-3">
  <!-- R53 (owner 2026-07-26): the calendar glyph sits INSIDE the input's right
       end, exactly like app-date-picker. It used to be an input-group-append —
       a second bordered box beside the field, which read as two controls and
       made the date field wider than its value. Same handlers, same #input. -->
  <div class="pc-input-wrapper">
    <input class="form-control form-control-sm pc-input" #input type="panchang" (click)="inputClick($event)"
      appFocusNext (keydown)="keyDownListener($event)" placeholder="{{placeholder}}" [disabled]="isDisable">
    <button class="pc-toggle-btn" type="button" tabindex="-1" [disabled]="isDisable"
      (mousedown)="$event.preventDefault(); $event.stopPropagation()" (click)="openCalendar($event)">
      <i class="fa fa-calendar"></i>
    </button>
  </div>
</div>
<!-- <input class="form-control form-control-sm" type="date"> -->

<ng-template #overlay>
  <!-- poojaBookingComp must be forwarded: the view inherits nextMonth/prevMonth
       from this component, and without the reference those handlers skip the
       availability refetch — month navigation then paints the new month with
       the previous month's blocked/partial data. -->
  <app-panchang-calendar-view [currentDate]="currentDate" [options]="options" [poojaBookingComp]="poojaBookingComp"
    (dateChanged)="onDateSelect($event)" (closePanchang)="onClosePanchang()">
  </app-panchang-calendar-view>
</ng-template>
<!-- 
<div class="cal-cell-row cal-header">
  <div class="cal-cell" *ngFor="let day of days; " 
  [class.cal-past]="day.isPast" [class.cal-today]="day.isToday"
 [class.cal-future]="day.isFuture" [class.cal-weekend]="day.isWeekend" 
 [ngClass]="day.cssClass">
 {{ day }}
  </div>
</div> -->